const AUTH_KEYS = ["access", "refresh", "userId", "username", "first_name", "last_name", "is_mentor"];

const normalizeStoredValue = (value) => {
  if (!value || value === "undefined" || value === "null") return null;
  return value;
};

export const getStoredAccessToken = () => normalizeStoredValue(localStorage.getItem("access"));

export const getStoredRefreshToken = () => normalizeStoredValue(localStorage.getItem("refresh"));

export const hasStoredAccessToken = () => Boolean(getStoredAccessToken());

export const persistAuthTokens = ({ access, refresh }) => {
  if (access) localStorage.setItem("access", access);
  if (refresh) localStorage.setItem("refresh", refresh);
};

export const persistUserSnapshot = (user) => {
  if (!user) return;
  localStorage.setItem("userId", String(user.id ?? ""));
  localStorage.setItem("username", user.username ?? "");
  localStorage.setItem("first_name", user.first_name ?? "");
  localStorage.setItem("last_name", user.last_name ?? "");
  localStorage.setItem("is_mentor", String(Boolean(user.is_mentor)));
};

export const getStoredUserSnapshot = () => {
  const username = normalizeStoredValue(localStorage.getItem("username"));
  const firstName = normalizeStoredValue(localStorage.getItem("first_name"));
  const lastName = normalizeStoredValue(localStorage.getItem("last_name"));
  const userId = normalizeStoredValue(localStorage.getItem("userId"));

  if (!username && !firstName && !lastName && !userId) {
    return null;
  }

  return {
    id: userId ? Number(userId) : null,
    username: username ?? "",
    first_name: firstName ?? "",
    last_name: lastName ?? "",
    is_mentor: localStorage.getItem("is_mentor") === "true",
  };
};

export const clearStoredAuth = () => {
  AUTH_KEYS.forEach((key) => localStorage.removeItem(key));
};
